function NewLineServiceType(type) {
    switch (type) {
      case "None":
        return "هیچکدام";
      case "Secretary":
        return "منشی";
      case "IVR":
        return "تلفن گویا";
      case "Fax":
        return "فکس";
      case "Voicemail":
        return "صندوق صوتی";
      default:
        return "";
    }
    
  }
  export default NewLineServiceType;
  